<template>
  <v-form>
    <v-row justify="center">
      <v-col cols="12" sm="9" xl="4">
        <h3 class="mb-4">{{ $t("message.posts.alertTitle") }}</h3>
        <p>{{ $t("message.posts.alertSubtitle") }}</p>
        <v-textarea
          name="text"
          v-model="form.text"
          counter="1500"
          v-validate="'required|max:1500'"
          :data-vv-name="$t('message.posts.alertName')"
          :error-messages="errors.collect($t('message.posts.alertName'))"
          :label="`${$t('message.posts.alertName')} *`"
          required
          rows="2"
          auto-grow
        ></v-textarea>

        <v-select
          :label="$t('message.posts.callToAction.label')"
          :items="[
            { name: $t('message.common.none'), value: 0 },
            ...callToActionItems
          ]"
          v-model="form.call_to_action.type"
          item-text="name"
          item-value="value"
        />

        <v-text-field
          v-if="form.call_to_action.type && form.call_to_action.type !== 6"
          name="url"
          v-model="form.call_to_action.url"
          v-validate="'required|url'"
          :data-vv-name="$t('message.posts.postUrl')"
          :error-messages="errors.collect($t('message.posts.postUrl'))"
          :label="`${$t('message.posts.postUrl')} *`"
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="9" xl="4">
        <PublicationDatePicker
          :type="type"
          :options="PUBLICATION_DATE_OPTIONS"
          :title="$t('message.posts.planning.publication.publicationDateTitle')"
          :subtitle="
            $t('message.posts.planning.publication.publicationDateSubtitle')
          "
          :edit-mode="editMode"
          :publish-at="form.publish_at"
          @change="handlePublicationDateChange"
        />
      </v-col>
    </v-row>
    <v-row justify="center" class="mt-4" no-gutters>
      <Footer>
        <ui-button color="primary" class="mr-8" @click="submit">
          {{ buttonLabel }}
        </ui-button>
        <ui-button
          outlined
          color="primary"
          icon="icon-search"
          @click="showPreview()"
        >
          {{ $t("message.posts.preview") }}
        </ui-button>
      </Footer>
    </v-row>
  </v-form>
</template>

<script>
import { debounce } from "@/helpers/helpers";

import { POSTS_CALL_TO_ACTION_TYPE } from "@/enums/posts.enum";
import { postFormMixin } from "@/helpers/mixins/post-form";

export default {
  name: "PostsAlertForm",

  model: {
    event: "setForm"
  },
  props: {
    value: { type: Object },
    editMode: {
      default: false,
      type: Boolean
    }
  },

  mixins: [postFormMixin],

  data() {
    return {
      items: Object.values(POSTS_CALL_TO_ACTION_TYPE),
      form: null
    };
  },

  created() {
    this.resetForm();
  },

  computed: {
    callToActionItems() {
      return this.items.map((item, index) => {
        return {
          name: this.$t(`message.posts.callToAction.${item}`),
          value: index + 1
        };
      });
    }
  },

  watch: {
    form: {
      handler: debounce(function(val) {
        this.setForm(val);
      }, 500),
      deep: true
    },
    "form.call_to_action.type": function(val) {
      if (!val || val === 6) {
        this.form.call_to_action.url = null;
      }
    }
  },
  methods: {
    setForm(val) {
      this.$emit("setForm", val);
    },
    setFormPreset(form) {
      if (form.alert_type) {
        form.alert_type = 1;
      }
      if (!form.call_to_action) {
        form.call_to_action = {
          type: null,
          url: null
        };
      }
      return form;
    },
    resetForm() {
      this.form = this.value.id
        ? this.setFormPreset(this.value)
        : {
            text: null,
            // hardcoded, no other options at the moment
            alert_type: 1,
            call_to_action: {
              type: null,
              url: null
            },
            publish_at: null
          };
    }
  }
};
</script>
